export default {
    getUrl: function () {
        return new URL(window.location.href);
    }
};
